import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fromStore } from '../../../selectors';
import cn from 'classnames';
import Loader from '../../../components/utils/Loader';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { fetchGoods, setActiveModalAction } from '../../../action';
import ReactTooltip from 'react-tooltip';
import { styles } from '../styles';
import { roleId } from '../../../constants/app';
import { getImageUrl } from '../../../utils/common';
import swal from 'sweetalert';
import ActionMenu from '../../../components/utils/ActionMenu';
import { deleteGroup, updateGroup } from '../../../action/groupgoods';

const TableHeader = () => (
    <thead className="kt-datatable__head">
        <tr className="kt-datatable__row">
        <th className='kt-datatable__cell' style={{ width: '30px', padding: 0 }}></th>
            <th className='kt-datatable__cell' style={{ width: '50px' }}><span>ID</span></th>
            {window.innerWidth > 830 && <th className='kt-datatable__cell good_preview'><span>Превью</span></th>}
            <th className='kt-datatable__cell' style={{ width: '150px' }}><span>Название</span></th>
            <th className='kt-datatable__cell' style={{ width: '150px' }}><span>Короткое название</span></th>
            <th style={{ textAlign: 'right' }} className='kt-datatable__cell table_action'><span>Действия</span></th>
        </tr>
    </thead>
);

const OptionRow = ({ item }) => {
    const dispatch = useDispatch();

    const onOpenModalGroup = (id) => {
        if (!id) return;
        dispatch(setActiveModalAction({ field: 'groupgood', value: id }));
    }
    return (
        <tr onDoubleClick={() => onOpenModalGroup(item.groupId)} key={`${item.groupId}_good`} className="kt-datatable__row" style={{ backgroundColor: '#d5d4ff61' }}>
            <td className='kt-datatable__cell' style={{ width: '30px', padding: 0 }}/>
            <td className='kt-datatable__cell' style={{ width: '50px' }}><span>{item.id}</span></td>
            {window.innerWidth > 830 && <td className='kt-datatable__cell good_preview'>
                <img width="50px" alt={'NaN'} src={getImageUrl(item.image)} />
            </td>}
            <td className='kt-datatable__cell' style={{ width: '150px' }}> <span>{item.name || ''}</span></td>
            <td className='kt-datatable__cell' style={{ width: '150px' }}>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <span style={{ verticalAlign: 'middle', lineHeight: 'normal' }}>{item.title || item.groupTitle}</span>
                    {item.isDefault && <span className="kt-badge kt-badge--success kt-badge--dot kt-badge--xl" />}    
                </div>        
            </td>
            <td align='right' className='kt-datatable__cell table_action'>
            </td>
        </tr>
    )
}

const ItemRow = ({ item }) => {
    const dispatch = useDispatch();
    const loaderUpdateGood = useSelector(fromStore.loaderUpdateGoodSelector);
    const loaderDeleteGood = useSelector(fromStore.loaderDeleteGoodSelector);
    const loaderUpdate = loaderUpdateGood === item.id;
    const loadertDelete = loaderDeleteGood === item.id;
    const user = useSelector(state => state.user.info);
    const [openItems, setOpenItems] = useState(false);

    const onOpenModalGroup = (id) => {
        if (!id) return;
        dispatch(setActiveModalAction({ field: 'groupgood', value: id }));
    }

    const onToogleActiveGroup = () => {
        const data = { 
            active: !item.active, 
            hiddenClient: item.active
        };
        dispatch(updateGroup(item.groupId, data))
    };

    const onToogleHiddenClientGroup = () => {
        const data = {hiddenClient: !item.hiddenClient };
        dispatch(updateGroup(item.groupId, data))
    };

    const onDeleteGroup = async () => {        
        swal({
            title: `Удаление группы`,
            text: `Вы действительно хотите удалить ${item.title}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(deleteGroup(item.groupId));
            }
        });
    }

    const handleClickOpen = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenItems(!openItems)
    }

    const actions = [
        { name: 'Редактировать', icon: 'la la-edit', action: () => onOpenModalGroup(item.groupId)},
        { name: 'Удалить', access: [roleId.admin, roleId.chiefCommoditySpecialist, roleId.chiefMarketingSpecialist], icon: 'la la-trash', action: () => onDeleteGroup()}
    ].filter((item) => !item.access || item.access.includes(user.role.id));    

    return (
        <>
            <tr onDoubleClick={() => onOpenModalGroup(item.groupId)} key={`${item.groupId}_good`} className="kt-datatable__row">
                <td onClick={handleClickOpen} onDoubleClick={e => e.stopPropagation()} style={{ cursor: 'pointer', width: '30px', padding: 0 }} className='kt-datatable__cell'>
                    <span style={{ display: 'flex', justifyContent: 'center' }}>
                        <i className={`kt-menu__ver-arrow la la-angle-${openItems ? 'up' : 'down'}`}/>
                    </span>
                </td>
                <td className='kt-datatable__cell' style={{ width: '50px' }}><span>{item.groupId}</span></td>
                {window.innerWidth > 830 && <td className='kt-datatable__cell good_preview'>
                    <img width="50px" alt={'NaN'} src={getImageUrl(item.image)} />
                </td>}
                <td className='kt-datatable__cell' style={{ width: '150px' }}><span>{item.title}</span></td>
                <td className='kt-datatable__cell' style={{ width: '150px' }}></td>
                <td align='right' className='kt-datatable__cell table_action'>
                    <div style={{ width: '100%', height: '100%'}}>
                        {!loadertDelete && !loaderUpdate && <ActionMenu actions={actions}/>} 
                        {(loadertDelete || loaderUpdate) && <span style={{overflow: 'visible', position: 'relative', width: '80px'}}><button className='btn btn-sm btn-clean btn-icon btn-icon-md kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--danger'></button></span> }
                        <button 
                            style={{ marginLeft: '5px' }}
                            onClick={onToogleActiveGroup}
                            data-tip={item.active ? 'Выключить' : 'Включить'}
                            disabled={loaderUpdate || loadertDelete}
                            className={cn("btn btn-sm btn-icon btn-icon-md", {
                                'btn-danger': !item.active,
                                'btn-success': item.active,
                                'kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--light': loaderUpdate
                            })}>
                            {!loaderUpdate && <i className="la la-power-off"></i>}
                        </button> 
                        <button
                            style={{ marginLeft: '5px' }} 
                            onClick={onToogleHiddenClientGroup}
                            data-tip={item.hiddenClient ? 'Показать' : 'Скрыть'}
                            disabled={loaderUpdate || loadertDelete}
                            className={cn("btn btn-sm btn-icon btn-icon-md", {
                                'btn-danger': item.hiddenClient,
                                'btn-success': !item.hiddenClient,
                                'kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--light': loaderUpdate
                            })}>
                            {!loaderUpdate && <i 
                                className={cn("la",{
                                    'la-eye-slash': item.hiddenClient,
                                    'la-eye': !item.hiddenClient
                                })}
                            ></i>}
                        </button> 
                    </div>     
                </td>
            </tr>
            {openItems && !isEmpty(item.items) && item.items.sort((a, b) => (b.order || 0) - (a.order || 0)).map((option) => <OptionRow item={option} />)}
        </>
    );

}

export function GroupsList() {
    const dispatch = useDispatch();
    const loaderList = useSelector(fromStore.loaderGoodsSelector);
    const loaderImport = useSelector(state => state.loaders.receipesImport);
    const goods = useSelector(fromStore.selectedCategoryGoods);
    const loading = loaderList || loaderImport;

    useEffect(() => ReactTooltip.rebuild(), [goods, loaderList]);

    useEffect(() => {
        isEmpty(goods) && dispatch(fetchGoods());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const filteredGoods = goods.filter((item) => item.isGroup);

    return (
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }}>
            <div className="kt-portlet kt-portlet--mobile">
                <div className="kt-portlet__body kt-portlet__body--fit">
                    <div
                        style={{ position: 'relative', marginBottom: 0 }}
                        className={
                            cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded', {
                                'kt-datatable--error': isEmpty(goods)
                            })
                        }>
                        {loading && <div style={styles.tableLoading}><Loader text='Загружаю товары'/></div>}
                        <table className="kt-datatable__table" style={{minHeight: '700px'}}>
                           <TableHeader/>
                                <tbody className="kt-datatable__body">
                                    {
                                        loading
                                            ? null
                                            : isEmpty(filteredGoods)
                                                ? <tr><td colSpan={8}><span className="kt-datatable--error">Группы не найдены</span></td></tr>
                                                : filteredGoods.map((item) => <ItemRow key={item.id} item={item}/>)
                                    }
                                </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ReactTooltip
                effect="solid"
                type="dark"
                place="top"
            />
        </div>
    );
}